import React, { useCallback } from 'react'
import { useAppDispatch } from 'reduxTyped'
import { Icon, l, Lozenge } from '@manychat/manyui'

import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'
import { useAccountReleaseToggle } from 'utils/services/featureFlagsService/releaseTogglesHooks'

import cm from './styles.module.css'

interface EmptyStateProps {
  disabled?: boolean
}

export const EmptyState = ({ disabled }: EmptyStateProps) => {
  const dispatch = useAppDispatch()

  const leadQualEnabled = useAccountReleaseToggle(AccountFlag.ENABLE_AI_LEADQUAL_GOAL)

  const handleClick = useCallback(
    (goal: GoalType) => {
      dispatch(
        AiAutomationLayoutActions.sidebarOpened({
          view: SidebarViewType.ENGAGEMENT_GOAL_EDITOR,
          payload: { goalType: goal },
        }),
      )
    },
    [dispatch],
  )

  return (
    <div className={cm.wrapper}>
      <ul className={cm.goalsList}>
        <li>
          <button
            onClick={() => handleClick(GoalType.LEAD_GEN)}
            className={cm.goalOption}
            disabled={disabled}
          >
            <Icon.Link size={20} />

            <span>
              <span className={cm.goalOption__title}>{l.translate('Share the link')}</span>

              <span className="text-sm text-secondary">
                {l.translate('Get your content out there')}
              </span>
            </span>
          </button>
        </li>

        <li>
          <button
            onClick={() => handleClick(GoalType.GROW_FOLLOWERS)}
            className={cm.goalOption}
            disabled={disabled}
          >
            <div className="d-flex justify-between align-center">
              <Icon.Community size={20} />
            </div>

            <span>
              <span className={cm.goalOption__title}>{l.translate('Get more followers')}</span>

              <span className="text-sm text-secondary">
                {l.translate('Ask newcomers to follow')}
              </span>
            </span>
          </button>
        </li>

        <li>
          <button
            onClick={() => handleClick(GoalType.LEAD_QUAL)}
            className={cm.goalOption}
            disabled={!leadQualEnabled || disabled}
          >
            <div className="d-flex justify-between align-center">
              <Icon.PublicChangelog size={20} />

              {!leadQualEnabled && <Lozenge type="soon" />}
            </div>

            <span>
              <span className={cm.goalOption__title}>{l.translate('Qualify leads')}</span>

              <span className="text-sm text-secondary">
                {l.translate('Follow-up to collect info')}
              </span>
            </span>
          </button>
        </li>
      </ul>
    </div>
  )
}
